// 模板 10：能源与环保监测平台

export default {
  home: {
    banners: [
      {
        img: require('@/assets/img/banner_2.jpg'),
        path: '',
        title: '能源管理与碳排放监测',
        content:
          '帮助园区与企业梳理能耗结构，量化碳排放，实现低碳转型。'
      },
      {
        img: require('@/assets/img/banner1.png'),
        path: '',
        title: '环境监测一张图',
        content:
          '实时呈现空气、水质与噪声等环境数据，辅助管理部门精细化监管。'
      }
    ],
    bigData: {
      img: require('@/assets/img/about_img.png'),
      title: '能源与环保数据中台',
      subtitle: '/ Energy & Environment Hub',
      paragraphs: [
        '平台集中管理多源能耗与环境监测数据，为节能减排提供数据基础。',
        '支持多维分析与看板配置，帮助管理者从不同视角洞察能耗与排放情况。'
      ],
      buttonText: '申请节能评估'
    },
    contact: {
      title: '低碳与环保管理数字化伙伴',
      subTitle: '让节能减排工作更可视、更可控',
      buttonText: '联系咨询顾问'
    },
    customers: [],
    advantages: []
  },
  company: {
    name: '绿脉能源科技有限公司',
    aboutImg: require('@/assets/img/about_img.png'),
    paragraphs: [
      '__COMPANY_NAME__专注能源管理与环保监测信息化建设，为工业园区、楼宇与企事业单位提供完整解决方案。',
      '公司致力于用数据驱动节能减排，让绿色发展不再停留在口号。'
    ]
  },
  news: [
    {
      id: 'EN01',
      title: '某产业园区能耗监测平台正式投运',
      introduce:
        '平台覆盖园区内主要建筑与关键用能设备，实现用能精细化管理。',
      date: '05-10',
      year: '2024'
    },
    {
      id: 'EN02',
      title: '推出碳排放核算模块',
      introduce:
        '按照相关标准对企业用能数据进行碳排放核算，辅助企业开展减排工作。',
      date: '01-22',
      year: '2024'
    },
    {
      id: 'EN03',
      title: '参与绿色园区建设研讨会',
      introduce:
        '分享在能耗监测与节能改造方面的项目经验，获得与会嘉宾认可。',
      date: '09-03',
      year: '2023'
    },
    {
      id: 'EN04',
      title: '上线环境监测预警功能',
      introduce:
        '在监测数据异常时自动触发预警，提醒相关人员及时处理。',
      date: '03-17',
      year: '2023'
    },
    {
      id: 'EN05',
      title: '与节能服务公司达成合作',
      introduce:
        '双方将结合技术与服务能力，共同为客户提供节能改造整体方案。',
      date: '07-29',
      year: '2022'
    }
  ],
  software: {
    smartTown: {
      title: '能源管理平台',
      sections: [
        {
          heading: '1. 分项能耗采集',
          content:
            '按分区、设备与工艺等维度采集能耗数据，帮助识别高能耗环节。'
        },
        {
          heading: '2. 能耗对标分析',
          content:
            '与历史数据与行业标杆对比，评估节能空间。'
        },
        {
          heading: '3. 能效诊断',
          content:
            '通过模型与规则分析能效水平，提出节能建议。'
        },
        {
          heading: '4. 报表与归档',
          content:
            '自动生成能耗报表，支持多格式导出与归档。'
        }
      ]
    },
    bigData: {
      title: '环境监测与预警系统',
      sections: [
        {
          heading: '1. 多源环境数据接入',
          desc:
            '对接空气、水质与噪声监测设备，实现数据集中管理。'
        },
        {
          heading: '2. 实时监控大屏',
          desc:
            '以地图与图表形式展示环境监测点位与指标。'
        },
        {
          heading: '3. 阈值与趋势预警',
          desc:
            '结合阈值与趋势变化进行预警，帮助尽早发现问题。'
        },
        {
          heading: '4. 环保报表生成',
          desc:
            '支持生成符合监管要求的报表，降低填报工作量。'
        }
      ]
    }
  },
  services: [
    {
      id: 'section-1',
      title: '能源审计与规划',
      engTitle: 'Energy Audit',
      img: require('@/assets/img/service1.jpg')
    },
    {
      id: 'section-2',
      title: '能耗监测系统实施',
      engTitle: 'EMS Delivery',
      img: require('@/assets/img/service2.jpg')
    },
    {
      id: 'section-3',
      title: '环保监测平台搭建',
      engTitle: 'Environment Platform',
      img: require('@/assets/img/service3.jpg')
    },
    {
      id: 'section-4',
      title: '节能改造咨询',
      engTitle: 'Energy Saving Consulting',
      img: require('@/assets/img/service4.jpg')
    }
  ],
  job: {
    title: '能源管理解决方案工程师',
    responsibilities: [
      '参与能源管理与环保监测项目方案设计与交付；',
      '调研客户现场能耗与环保现状，提出改进建议；',
      '协助产品与研发团队优化相关功能。'
    ],
    requirements: [
      '具备能源管理或环保相关专业背景优先；',
      '具备良好的沟通与方案表达能力；',
      '对绿色低碳与可持续发展有兴趣。'
    ],
    buttonText: '加入低碳团队'
  }
};





// WEBPACK FOOTER //
// ./src/config/templates-10.js